import { render } from "./DescriptionElement.vue?vue&type=template&id=35e358a6"
import script from "./DescriptionElement.vue?vue&type=script&lang=js"
export * from "./DescriptionElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__